var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "sendMessage"
  }, [_c('Verify', {
    ref: "verify",
    attrs: {
      "captcha-type": 'blockPuzzle',
      "img-size": {
        width: '300px',
        height: '200px'
      }
    },
    on: {
      "success": _vm.success
    }
  }), _c('Form', {
    ref: "form",
    attrs: {
      "model": _vm.value,
      "rules": _vm.ruleValidate,
      "label-position": "top"
    },
    nativeOn: {
      "submit": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_vm.accountType === 'MOBILE' ? _c('div', {
    staticClass: "formItem"
  }, [_vm.showText ? _c('div', {
    staticClass: "register_column_item_title",
    class: [{
      register_column_item_title_require: !_vm.exist
    }]
  }, [_vm._v(` ${$t("cttsc24", "手机号:")} `)]) : _vm._e(), _c('FormItem', {
    staticClass: "input",
    attrs: {
      "prop": "mobile"
    }
  }, [!_vm.exist ? _c('countryCode', {
    ref: "countryCode",
    on: {
      "emitMobileCode": _vm.emitMobileCode
    },
    model: {
      value: _vm.value,
      callback: function ($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.value.mobileAreaCode || "+86") + "-" + _vm._s(_vm.value.mobileMi || _vm.value.mobile))])], 1)], 1) : _c('div', {
    staticClass: "formItem"
  }, [_vm.showText ? _c('div', {
    staticClass: "register_column_item_title",
    class: [{
      register_column_item_title_require: !_vm.exist
    }]
  }, [_vm._v(` ${$t("lrxlj3", "邮箱:")} `)]) : _vm._e(), _vm.exist ? _c('div', {
    staticClass: "input",
    staticStyle: {
      "line-height": "32px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.value.emailMi || _vm.value.email))])]) : _c('FormItem', {
    staticClass: "input",
    attrs: {
      "prop": "email"
    }
  }, [_c('Input', {
    attrs: {
      "maxlength": "50",
      "element-id": "sendMessageInputEmail",
      "placeholder": $t("2j0utw5", "请输入邮箱")
    },
    on: {
      "input": () => _vm.onInputRange(this, _vm.value, 'email', 'sendMessageInputEmail')
    },
    model: {
      value: _vm.value.email,
      callback: function ($$v) {
        _vm.$set(_vm.value, "email", $$v);
      },
      expression: "value.email"
    }
  })], 1)], 1), _c('div', {
    staticClass: "formItem formItemVer"
  }, [_vm.showText ? _c('div', {
    staticClass: "register_column_item_title register_column_item_title_require"
  }, [_vm._v(" " + _vm._s(_vm.accountType === "MOBILE" ? $t("hl49ig5", "短信验证码") : $t("dp1ljd5", "邮箱验证码")) + ": ")]) : _vm._e(), _c('FormItem', {
    staticClass: "input verificationCode",
    attrs: {
      "prop": "verificationCode"
    }
  }, [_c('Input', {
    staticClass: "verificationInput",
    attrs: {
      "maxlength": "6",
      "disabled": !_vm.canSend,
      "pattern": "\\d*",
      "placeholder": $t("nbcoc3", "验证码")
    },
    on: {
      "on-enter": _vm.onEnter
    },
    model: {
      value: _vm.value.verificationCode,
      callback: function ($$v) {
        _vm.$set(_vm.value, "verificationCode", $$v);
      },
      expression: "value.verificationCode"
    }
  })], 1), _c('div', {
    staticClass: "verificationBtn"
  }, [!_vm.canSend || _vm.disabled ? _c('span', [_vm._v(_vm._s(_vm.text || _vm.newText))]) : _c('span', {
    staticClass: "button",
    on: {
      "click": _vm.getCode
    }
  }, [_vm._v(_vm._s(_vm.text || _vm.newText))])])], 1)])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };